import React from 'react';

//components
import HomeSection from "../HomeSection";
import Contact from "../Sections/Contact";

//style
import "./Footer.scss"

//svg

const Footer = () => {
    return (
		<footer className="main-footer" id="contact">
            <HomeSection boxed>
                <Contact />
            </HomeSection>
        </footer>
    );
};

export default Footer;